/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { bemGenerator } from '@prisjakt/ui-base';
import { ScrollElement } from '@prisjakt/ui-scroll';

import Banner from '../banner';
import AdContainer from '../../../../components/ads';

import './index.scss';

const styles = bemGenerator('campaign-header', [
  'ads',
  'logo',
  'container',
  'content',
  'content-mobile',
  'title',
  'description',
  'tagline',
]);

const CampaignHeader = props => {
  const { renderMode } = useContext(AppContext);
  return props.campaign ? (
    <div className={`${styles.block} row`}>
      <div className={styles.container}>
        <div className={styles.logo}>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            href=""
            onClick={event => {
              event.preventDefault();
              props.onClear();
            }}
          >
            <Banner
              banners={props.campaign.banners}
              type="banner_logo_big"
              alt={props.campaign.title.page}
            />
          </a>
        </div>
        <div className={styles.content}>
          <h1 className={styles.title}>{props.campaign.title.page}</h1>

          <p
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: props.campaign.descriptionHtml.page,
            }}
          />

          <p className={styles.tagline}>{props.campaign.tagline}</p>
        </div>
        {renderMode === 'desktop' && (
          <AdContainer placement="small_insider_1" min={640} max={10000} />
        )}
      </div>
      <div className={styles.ads}>
        <ScrollElement name="CampaignHeaderAd">
          <AdContainer placement="dubbelpanorama1" min={0} max={639} />
        </ScrollElement>
      </div>
    </div>
  ) : null;
};

const { shape, string, number, bool, arrayOf, func } = PropTypes;

CampaignHeader.propTypes = {
  campaign: shape({
    id: number.isRequired,
    title: shape({
      short: string,
    }),
    description: shape({
      short: string,
    }),
    descriptionHtml: shape({
      long: string,
    }),
    banners: arrayOf(
      shape({
        type: string,
        url: string,
        imageUrl: string,
      })
    ),
  }).isRequired,
  isActive: bool.isRequired,
  onClear: func.isRequired,
};

export default CampaignHeader;
